module.exports = __webpack_public_path__ + "static/media/wealthM.5757090e.svg";